/** Tells interested parties (the resource sync) that a player action went through the API. */
const handlers = new Set<() => void>();

export function onApiMutation(fn: () => void): () => void {
  handlers.add(fn);
  return () => { handlers.delete(fn); };
}

/** Paths whose success cannot change the stockpile. */
const IGNORED = /^\/(auth|account|me\/|onboarding|feedback|push|legal|economy\/acknowledge|admin)/;

export function notifyApiMutation(method: string | undefined, path: string): void {
  if (!method || method.toUpperCase() === 'GET' || IGNORED.test(path)) return;
  handlers.forEach(fn => fn());
}
